import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, MailIcon } from 'lucide-react';
const TermsOfServicePage = () => {
  return <div className="min-h-screen bg-gray-50" data-id="element-4187">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-4188">
        {/* Header */}
        <div className="mb-12" data-id="element-4189">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6" data-id="element-4190">
            <ArrowLeftIcon className="h-4 w-4" data-id="element-4191" />
            Back to Home
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-4192">
            Terms of Service
          </h1>
          <p className="text-gray-600 mb-2" data-id="element-4193">Last Updated: January 17, 2026</p>
          <p className="text-gray-900 font-semibold" data-id="element-4194">
            Business Name: Shopilots AI
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-12" data-id="element-4195">
          <div className="prose prose-lg max-w-none" data-id="element-4196">
            <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-4197">
              Welcome to ShoPilots AI. Please read these Terms of Service
              carefully before using our platform.
            </p>

            <section className="mb-10" data-id="element-4198">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4199">
                1. Agreement to Terms
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4200">
                By accessing or using ShoPilots AI ("Service," "Platform," "we,"
                "us," or "our"), you agree to be bound by these Terms of Service
                and our Privacy Policy. If you do not agree to these terms, do
                not use our Service.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-4201">
                ShoPilots AI is currently operating as a trade name and does not
                yet have a formal legal entity. A legal entity will be
                established in the future, at which point these terms will be
                updated accordingly.
              </p>
            </section>

            <section className="mb-10" data-id="element-4202">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4203">
                2. Description of Service
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4204">
                2.1 Automated Service
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4205">
                ShoPilots AI provides an automated, self-service platform that
                enables you to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-4206">
                <li data-id="element-4207">
                  Transform your website data into AI-powered agents using
                  automated tools
                </li>
                <li data-id="element-4208">
                  Deploy conversational AI across multiple channels (website
                  widgets, WhatsApp, Telegram, etc.)
                </li>
                <li data-id="element-4209">
                  Create AI-powered customer experiences through our automated
                  platform
                </li>
              </ul>
              <div className="bg-purple-50 border-l-4 border-purple-500 p-4 mb-4" data-id="element-4210">
                <p className="font-semibold text-gray-900 mb-2" data-id="element-4211">
                  This is a fully automated software service.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-4212">
                  No human-driven services, manual consulting, or custom
                  development are included in the standard subscription. All AI
                  agent creation, deployment, and management is performed
                  through our automated platform tools.
                </p>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4213">
                2.2 Your Responsibilities
              </h3>
              <div className="bg-orange-50 border-l-4 border-orange-500 p-4 mb-4" data-id="element-4214">
                <p className="font-semibold text-gray-900 mb-2" data-id="element-4215">IMPORTANT:</p>
                <p className="text-gray-700 leading-relaxed mb-2" data-id="element-4216">
                  ShoPilots AI is a platform provider and technology enabler
                  only. We provide the tools and infrastructure. You are solely
                  responsible for:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-gray-700" data-id="element-4217">
                  <li data-id="element-4218">The content and data you upload</li>
                  <li data-id="element-4219">How you configure and use the AI agents</li>
                  <li data-id="element-4220">
                    All outputs, responses, and interactions generated by your
                    AI agents
                  </li>
                  <li data-id="element-4221">
                    Ensuring compliance with all applicable laws and regulations
                  </li>
                  <li data-id="element-4222">
                    The accuracy, legality, and appropriateness of all
                    AI-generated content
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-10" data-id="element-4223">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4224">
                3. Eligibility
              </h2>
              <p className="text-gray-700 leading-relaxed" data-id="element-4225">
                You must be at least 18 years old to use this Service. By using
                the Service, you represent and warrant that you are 18 years of
                age or older.
              </p>
            </section>

            <section className="mb-10" data-id="element-4226">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4227">
                4. Account Registration and Subscription
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4228">
                4.1 Registration
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4229">
                You must provide accurate and complete information when creating
                an account. You are responsible for maintaining the
                confidentiality of your account credentials.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4230">
                4.2 Subscription and Payment
              </h3>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-4231">
                <li data-id="element-4232">Service is provided on a monthly subscription basis</li>
                <li data-id="element-4233">
                  Payment is processed at the beginning of each billing month
                  through our payment processor (Paddle)
                </li>
                <li data-id="element-4234">Paddle is the Merchant of Record for all transactions</li>
                <li data-id="element-4235">Billing and invoicing are handled by Paddle</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4236">
                4.3 Cancellation and Refunds
              </h3>

              <p className="font-semibold text-gray-900 mb-2" data-id="element-4237">Cancellation:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-4238">
                <li data-id="element-4239">You may cancel your subscription at any time</li>
                <li data-id="element-4240">
                  Cancellation takes effect at the end of your current billing
                  period
                </li>
                <li data-id="element-4241">
                  You will continue to have access to the Service until the end
                  of the paid period
                </li>
              </ul>

              <div className="bg-purple-50 border-l-4 border-purple-500 p-4 mt-4" data-id="element-4242">
                <p className="font-semibold text-gray-900 mb-2" data-id="element-4243">
                  Refund Policy:
                </p>
                <p className="text-gray-700 leading-relaxed mb-3" data-id="element-4244">
                  Refunds are provided at the sole discretion of Paddle (our
                  payment processor and merchant of record) and are handled on a
                  case-by-case basis. Refund requests may be approved or refused
                  at Paddle's discretion.
                </p>
                <p className="text-gray-700 leading-relaxed mb-3" data-id="element-4245">
                  To request a refund, please contact{' '}
                  <a href="mailto:info@shopilots.com" className="text-orange-600 hover:text-orange-700 underline" data-id="element-4246">
                    info@shopilots.com
                  </a>{' '}
                  with your order details, and we will work with Paddle to
                  process your request.
                </p>
                <p className="text-gray-700 leading-relaxed italic" data-id="element-4247">
                  This does not affect your rights as a consumer in relation to
                  products or services which are not as described, faulty, or
                  not fit for purpose.
                </p>
              </div>
            </section>

            <section className="mb-10" data-id="element-4248">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4249">
                5. Acceptable Use Policy
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4250">
                You agree NOT to use the Service to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-4251">
                <li data-id="element-4252">
                  Violate any applicable local, national, or international law
                </li>
                <li data-id="element-4253">Infringe upon intellectual property rights of others</li>
                <li data-id="element-4254">Generate, distribute, or promote illegal content</li>
                <li data-id="element-4255">
                  Create content that is defamatory, harassing, threatening, or
                  hateful
                </li>
                <li data-id="element-4256">
                  Generate adult, sexually explicit, or inappropriate content
                </li>
                <li data-id="element-4257">
                  Provide medical, legal, or financial advice without proper
                  disclaimers
                </li>
                <li data-id="element-4258">Impersonate any person or entity</li>
                <li data-id="element-4259">Collect or harvest personal information without consent</li>
                <li data-id="element-4260">Distribute malware, viruses, or harmful code</li>
                <li data-id="element-4261">Interfere with or disrupt the Service or servers</li>
              </ul>
              <p className="text-gray-700 leading-relaxed" data-id="element-4262">
                You must also comply with the usage policies of our AI providers
                (including OpenAI and Anthropic Claude). Violations of their
                policies constitute violations of these Terms.
              </p>
            </section>

            <section className="mb-10" data-id="element-4263">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4264">
                6. Content and Data Ownership
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4265">
                6.1 Your Content
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4266">
                You retain ownership of all data, content, and materials you
                upload to the Service ("Your Content"). By uploading Your
                Content, you grant us a limited license to use, process, and
                store it solely for the purpose of providing the Service to you.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4267">
                6.2 Our Platform
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4268">
                We retain all rights, title, and interest in the ShoPilots AI
                platform, including all software, technology, algorithms, and
                intellectual property.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4269">
                6.3 AI-Generated Content
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-4270">
                You acknowledge that AI-generated content is created using
                third-party AI models (OpenAI, Anthropic Claude, etc.). We do
                not claim ownership of AI outputs, but we also do not guarantee
                their accuracy, appropriateness, or compliance with any laws or
                regulations.
              </p>
            </section>

            <section className="mb-10" data-id="element-4271">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4272">
                7. Third-Party AI Services
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4273">
                7.1 AI Provider Dependencies
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4274">
                Our Service relies on third-party AI providers (including OpenAI
                and Anthropic). These providers:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-4275">
                <li data-id="element-4276">
                  Have their own terms of service and usage policies that apply
                  to you
                </li>
                <li data-id="element-4277">
                  May change their services, pricing, or availability at any
                  time
                </li>
                <li data-id="element-4278">May experience downtime or service interruptions</li>
                <li data-id="element-4279">
                  Process your data according to their own privacy policies
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4280">
                7.2 No Guarantees
              </h3>
              <p className="text-gray-700 leading-relaxed mb-2" data-id="element-4281">
                We do not guarantee:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-4282">
                <li data-id="element-4283">
                  The accuracy, completeness, or reliability of AI-generated
                  responses
                </li>
                <li data-id="element-4284">Continuous availability of AI services</li>
                <li data-id="element-4285">
                  That AI outputs will be appropriate for your specific use case
                </li>
                <li data-id="element-4286">Compliance with any industry-specific regulations</li>
              </ul>
            </section>

            <section className="mb-10" data-id="element-4287">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4288">
                8. Your Responsibilities and Compliance
              </h2>
              <div className="bg-orange-50 border-l-4 border-orange-500 p-4 mb-4" data-id="element-4289">
                <p className="font-semibold text-gray-900 mb-2" data-id="element-4290">
                  YOU ARE SOLELY RESPONSIBLE FOR:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-4291">
                  <li data-id="element-4292">
                    Compliance with all applicable laws and regulations
                    (including GDPR, CCPA, data protection laws, consumer
                    protection laws, etc.)
                  </li>
                  <li data-id="element-4293">
                    Accuracy and truthfulness of all AI-generated content shown
                    to your customers
                  </li>
                  <li data-id="element-4294">
                    Obtaining necessary consents from your users for data
                    collection and AI interactions
                  </li>
                  <li data-id="element-4295">
                    Providing appropriate disclaimers to your users about
                    AI-generated content
                  </li>
                  <li data-id="element-4296">
                    Monitoring and reviewing AI outputs for accuracy and
                    appropriateness
                  </li>
                  <li data-id="element-4297">
                    Implementing safeguards to prevent harmful or inappropriate
                    content
                  </li>
                  <li data-id="element-4298">
                    Industry-specific compliance (medical, legal, financial
                    services regulations, etc.)
                  </li>
                  <li data-id="element-4299">
                    Intellectual property compliance - ensuring you have rights
                    to all uploaded content
                  </li>
                  <li data-id="element-4300">
                    Testing and validating the AI agent before deploying to
                    customers
                  </li>
                </ul>
              </div>
              <p className="text-gray-700 leading-relaxed" data-id="element-4301">
                We are only a technology platform provider. We do not review,
                monitor, or control the content generated by your AI agents.
              </p>
            </section>

            <section className="mb-10" data-id="element-4302">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4303">
                9. Disclaimers and Limitation of Liability
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4304">
                9.1 Service "AS IS"
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4 font-semibold" data-id="element-4305">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT
                WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT
                NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4306">
                9.2 No Liability for AI Outputs
              </h3>
              <p className="text-gray-700 leading-relaxed mb-2 font-semibold" data-id="element-4307">
                WE ARE NOT LIABLE FOR:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-4308">
                <li data-id="element-4309">Any AI-generated content, responses, or outputs</li>
                <li data-id="element-4310">Inaccuracies, errors, or hallucinations in AI responses</li>
                <li data-id="element-4311">
                  Damages arising from your use or reliance on AI-generated
                  content
                </li>
                <li data-id="element-4312">Business losses, lost profits, or indirect damages</li>
                <li data-id="element-4313">
                  Actions taken by your customers based on AI interactions
                </li>
                <li data-id="element-4314">Regulatory fines or penalties you incur</li>
                <li data-id="element-4315">
                  Data breaches or security incidents at third-party AI
                  providers
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4316">
                9.3 Maximum Liability
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4 font-semibold" data-id="element-4317">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR TOTAL LIABILITY TO
                YOU FOR ANY CLAIMS ARISING FROM OR RELATED TO THE SERVICE SHALL
                NOT EXCEED THE AMOUNT YOU PAID US IN THE 12 MONTHS PRECEDING THE
                CLAIM.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4318">
                9.4 Use at Your Own Risk
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-4319">
                You acknowledge that you use the Service entirely at your own
                risk. You are responsible for evaluating whether the Service
                meets your needs and for implementing appropriate safeguards.
              </p>
            </section>

            <section className="mb-10" data-id="element-4320">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4321">
                10. Indemnification
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4322">
                You agree to indemnify, defend, and hold harmless ShoPilots AI,
                its operators, employees, and affiliates from and against any
                and all claims, damages, losses, liabilities, costs, and
                expenses (including reasonable attorneys' fees) arising from or
                related to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-4323">
                <li data-id="element-4324">Your use of the Service</li>
                <li data-id="element-4325">AI content generated through your account</li>
                <li data-id="element-4326">Your violation of these Terms</li>
                <li data-id="element-4327">Your violation of any applicable laws or regulations</li>
                <li data-id="element-4328">
                  Any claims by your customers or third parties related to AI
                  interactions
                </li>
                <li data-id="element-4329">
                  Your failure to obtain necessary consents or provide required
                  disclaimers
                </li>
                <li data-id="element-4330">
                  Infringement of intellectual property rights through your
                  uploaded content
                </li>
              </ul>
            </section>

            <section className="mb-10" data-id="element-4331">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4332">
                11. Data and Privacy
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4333">
                11.1 Data Collection
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4334">
                We collect and process data as described in our{' '}
                <Link to="/privacy-policy" className="text-orange-600 hover:text-orange-700 underline" data-id="element-4335">
                  Privacy Policy
                </Link>
                . By using the Service, you consent to such collection and
                processing.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4336">
                11.2 Data Security
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4337">
                While we implement reasonable security measures, we cannot
                guarantee absolute security. You acknowledge the inherent risks
                of internet-based services.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4338">
                11.3 Data Retention
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4339">
                We retain your data for as long as necessary to provide the
                Service and comply with legal obligations. You may request
                deletion of your data upon account termination, subject to legal
                retention requirements.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4340">
                11.4 International Data Transfers
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-4341">
                Our Service may involve data transfers to countries outside your
                jurisdiction, including to the United States where our AI
                providers are located.
              </p>
            </section>

            <section className="mb-10" data-id="element-4342">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4343">
                12. Modifications to Service and Terms
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4344">
                12.1 Service Changes
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4345">
                We reserve the right to modify, suspend, or discontinue any part
                of the Service at any time with or without notice.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4346">
                12.2 Terms Updates
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4347">
                We may update these Terms at any time. We will notify you of
                material changes via email or through the Service. Continued use
                after changes constitutes acceptance of the updated Terms.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4348">
                12.3 Pricing Changes
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-4349">
                We reserve the right to change our pricing with 30 days' notice.
                Price changes will apply at your next billing cycle.
              </p>
            </section>

            <section className="mb-10" data-id="element-4350">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4351">
                13. Termination
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4352">
                13.1 By You
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4353">
                You may terminate your account at any time through your account
                settings or by contacting us. Termination is effective at the
                end of your current billing period.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4354">
                13.2 By Us
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4355">
                We may suspend or terminate your account immediately if:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4" data-id="element-4356">
                <li data-id="element-4357">You violate these Terms</li>
                <li data-id="element-4358">You engage in prohibited activities</li>
                <li data-id="element-4359">Your use poses security or legal risks</li>
                <li data-id="element-4360">Required by law or third-party AI providers</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4361">
                13.3 Effect of Termination
              </h3>
              <p className="text-gray-700 leading-relaxed mb-2" data-id="element-4362">
                Upon termination:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700" data-id="element-4363">
                <li data-id="element-4364">Your access to the Service will cease</li>
                <li data-id="element-4365">Your AI agents will be deactivated</li>
                <li data-id="element-4366">
                  We may delete your data after a reasonable retention period
                </li>
                <li data-id="element-4367">
                  You remain liable for all fees incurred prior to termination
                </li>
              </ul>
            </section>

            <section className="mb-10" data-id="element-4368">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4369">
                14. Intellectual Property
              </h2>
              <p className="text-gray-700 leading-relaxed" data-id="element-4370">
                All trademarks, service marks, logos, and trade names associated
                with ShoPilots AI are our property or the property of our
                licensors. You may not use them without our prior written
                consent.
              </p>
            </section>

            <section className="mb-10" data-id="element-4371">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4372">
                15. Dispute Resolution
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4373">
                15.1 Governing Law
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4374">
                These Terms shall be governed by and construed in accordance
                with the laws of Israel, without regard to conflict of law
                principles.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4375">
                15.2 Informal Resolution
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4376">
                Before initiating formal proceedings, you agree to contact us to
                attempt to resolve any dispute informally.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4377">
                15.3 Jurisdiction
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-4378">
                Any legal action or proceeding arising under these Terms will be
                brought exclusively in the courts located in Israel, and you
                consent to personal jurisdiction in such courts.
              </p>
            </section>

            <section className="mb-10" data-id="element-4379">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4380">
                16. General Provisions
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4381">
                16.1 Entire Agreement
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4382">
                These Terms, together with our Privacy Policy, constitute the
                entire agreement between you and ShoPilots AI regarding the
                Service.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4383">
                16.2 Severability
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4384">
                If any provision of these Terms is found to be unenforceable,
                the remaining provisions will remain in full effect.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4385">
                16.3 No Waiver
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4386">
                Our failure to enforce any right or provision of these Terms
                will not constitute a waiver of such right or provision.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4387">
                16.4 Assignment
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4388">
                You may not assign or transfer these Terms without our written
                consent. We may assign these Terms without restriction.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-4389">
                16.5 No Agency
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-4390">
                Nothing in these Terms creates any agency, partnership, joint
                venture, or employment relationship.
              </p>
            </section>

            <section className="mb-10" data-id="element-4391">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-4392">
                17. Contact Information
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-4393">
                For questions about these Terms of Service, please contact:
              </p>
              <div className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-id="element-4394">
                <div className="mb-4" data-id="element-4395">
                  <p className="font-semibold text-gray-900 mb-1" data-id="element-4396">
                    Legal Business Name
                  </p>
                  <p className="text-gray-700" data-id="element-4397">Shopilots AI</p>
                </div>
                <div className="flex items-start gap-3 mb-3" data-id="element-4398">
                  <MailIcon className="h-5 w-5 text-orange-600 mt-0.5" data-id="element-4399" />
                  <div data-id="element-4400">
                    <p className="font-semibold text-gray-900" data-id="element-4401">Email</p>
                    <a href="mailto:info@shopilots.com" className="text-orange-600 hover:text-orange-700" data-id="element-4402">
                      info@shopilots.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3 mb-3" data-id="element-4403">
                  <div className="h-5 w-5" data-id="element-4404"></div>
                  <div data-id="element-4405">
                    <p className="font-semibold text-gray-900" data-id="element-4406">Location</p>
                    <p className="text-gray-700" data-id="element-4407">Israel</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-4408">
                  <div className="h-5 w-5" data-id="element-4409"></div>
                  <div data-id="element-4410">
                    <p className="font-semibold text-gray-900" data-id="element-4411">
                      Payment Processor
                    </p>
                    <p className="text-gray-700" data-id="element-4412">Paddle (Merchant of Record)</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Summary Box */}
            <div className="bg-purple-50 border-2 border-purple-200 rounded-lg p-6 mt-12" data-id="element-4413">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-4414">
                KEY PROTECTIONS (Summary)
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-4415">These Terms protect you by:</p>
              <ul className="space-y-2 text-gray-700" data-id="element-4416">
                <li className="flex items-start gap-2" data-id="element-4417">
                  <span className="text-green-600 mt-1" data-id="element-4418">✓</span>
                  <span data-id="element-4419">
                    Disclaiming liability for AI outputs - You're not
                    responsible for what the AI says
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4420">
                  <span className="text-green-600 mt-1" data-id="element-4421">✓</span>
                  <span data-id="element-4422">
                    Making customers responsible for compliance - They must
                    check regulations, not you
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4423">
                  <span className="text-green-600 mt-1" data-id="element-4424">✓</span>
                  <span data-id="element-4425">
                    "As is" service provision - No guarantees on accuracy or
                    availability
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4426">
                  <span className="text-green-600 mt-1" data-id="element-4427">✓</span>
                  <span data-id="element-4428">
                    Indemnification clause - Customers protect you from their
                    usage
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4429">
                  <span className="text-green-600 mt-1" data-id="element-4430">✓</span>
                  <span data-id="element-4431">
                    Limited liability - Maximum exposure capped at subscription
                    fees
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4432">
                  <span className="text-green-600 mt-1" data-id="element-4433">✓</span>
                  <span data-id="element-4434">
                    Paddle-managed refunds - Refund decisions handled by payment
                    processor
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4435">
                  <span className="text-green-600 mt-1" data-id="element-4436">✓</span>
                  <span data-id="element-4437">
                    Automated service disclosure - No manual/human services
                    included
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-4438">
                  <span className="text-green-600 mt-1" data-id="element-4439">✓</span>
                  <span data-id="element-4440">
                    Third-party dependency disclosure - AI provider risks are
                    acknowledged
                  </span>
                </li>
              </ul>
              <p className="text-gray-700 mt-4 font-medium" data-id="element-4441">
                By using ShoPilots AI, customers acknowledge they are using the
                service at their own risk and are responsible for ensuring their
                use complies with all applicable laws and regulations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TermsOfServicePage;